const isLandscape = () => `(orientation: landscape)`;

export const orientation = {
  isLandscape,
};
